'use client'

import { useState, useEffect } from 'react'
import CookieConsentBanner from '@/components/CookieConsentBanner'

export default function ClientCookieBanner() {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  // Only render the banner on the client side
  if (!isClient) {
    return null
  }

  return <CookieConsentBanner key="cookie-banner-unique" />
}
